/*
  Ajout rapide au panier depuis les cartes produit (snippets/mh-card-product.liquid, mh-card-cross-sell.liquid).
  Cart.js, Rivets et le mini-panier sont chargés en différé, à la première interaction (assets/load-scripts.js).
  Sur mobile, le premier toucher est souvent celui sur le bouton panier : sans Cart.js, le formulaire partait
  vers /cart/add, puis /cart renvoyait à l'accueil (rechargement, retour en haut de page).
  Tant que Cart.js n'est pas prêt, ce script ajoute le produit en arrière-plan (/cart/add.js), lance le
  chargement des scripts différés puis ouvre le mini-panier (évènement « mini-cart:refresh » de
  assets/mini_cart.js), comme sur la fiche produit. Une fois Cart.js prêt, il le laisse faire.
  Chargé sur toutes les pages (snippets/mh-tokens.liquid), sans attendre.
*/
(() => {
  const FORMS = 'form.mh-card-product__form, form.mh-card-cross-sell__form';

  const documentEvents = () => (window.jQuery?._data ? window.jQuery._data(document, 'events') || {} : {});
  // Cart.js est initialisé quand il écoute les formulaires [data-cart-submit] (CartJS.init, theme.liquid)
  const cartReady = () => (documentEvents().submit || []).some((handler) => String(handler.selector || '').includes('data-cart-submit'));
  const miniCartReady = () => cartReady() && (documentEvents()['mini-cart:refresh'] || []).length > 0;

  function loadDeferredScripts() {
    if (typeof window.loadJSscripts !== 'function' || window.script_loaded) return;
    // load-scripts.js ignore son premier appel (premier évènement) : deux appels pour lancer le chargement
    window.loadJSscripts();
    if (!window.script_loaded) window.loadJSscripts();
  }

  function whenMiniCartReady(timeout = 30000) {
    return new Promise((resolve, reject) => {
      const start = Date.now();
      (function check() {
        if (miniCartReady()) return resolve();
        if (Date.now() - start > timeout) return reject(new Error('mini-cart'));
        setTimeout(check, 100);
      })();
    });
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest?.(FORMS);
    if (!form || cartReady()) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.mhAdding) return;
    form.dataset.mhAdding = 'true';
    const button = form.querySelector('[type="submit"]');
    button?.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      loadDeferredScripts();
      await whenMiniCartReady();
      window.jQuery(document).trigger('mini-cart:refresh');
    } catch (error) {
      // Ajout refusé par Shopify (stock…) : envoi classique du formulaire, qui affiche le message d'erreur.
      // Mini-panier pas prêt à temps : le produit est déjà ajouté, rien à faire de plus
      if (error.message.startsWith('HTTP')) HTMLFormElement.prototype.submit.call(form);
    } finally {
      delete form.dataset.mhAdding;
      button?.removeAttribute('aria-busy');
    }
  }, true);
})();
